import {
    Brokers,
    // GetBrokerLoginUrlRequest,
    // GetBrokerLoginUrlResponse,
    TradingAccount,
    TradingAccountMargin,
    TradingAccounts
} from '../../proto/generated/trading-bridge'
import api from './axiosClient'
import store from '../../store'
import { setMarginForAccount, setTradingAccounts, UserStateType } from '../../reducer/user.reducer'
import { PRIMARY_TRADING_ACCOUNT_KEY } from '../../assets/constants'
import { MarginFromBrokerRequest, MarginFromBrokerResponse } from '../../proto/generated/order'
import { PositionRequest } from '../../proto/generated/position'
import { getOrders, getPositions } from './orders'
import { updatePositions } from '../../reducer/positions.reducer'
import { setOrderHistory } from '../../reducer/orders.reducer'


export const getBrokers = async (): Promise<Brokers> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts/brokers`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = Brokers.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getTradingAccounts = async (): Promise<TradingAccounts> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccounts.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const removeTradingAccount = async (args: { body: any }): Promise<TradingAccounts> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts`
        api.delete(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            data: JSON.stringify(args.body),
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccounts.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

// export const getBrokerLoginUrl = async (args: { body: GetBrokerLoginUrlRequest }): Promise<GetBrokerLoginUrlResponse> => {
//     return new Promise((resolve, reject) => {
//         const url = `/trading-accounts/login-url`
//         api.post(url, JSON.stringify(args.body), {
//             headers: {
//                 'Accept': 'application/x-protobuf'
//             },
//             responseType: 'arraybuffer'
//         }).then(async (response) => {
//             const decodedData = GetBrokerLoginUrlResponse.decode(new Uint8Array(response.data))
//             resolve(decodedData)
//         }).catch((error) => {
//             reject(error)
//         })
//     })
// }

export const getBrokerLoginUrl = async (_args: { body: any }): Promise<{ loginUrl: string }> => {
    return { loginUrl: '' }
}

export const getAccountMargins = async (args: { body: any }): Promise<TradingAccountMargin> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts/margins`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccountMargin.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const getRequiredMarginFromBroker = async (args: {request: MarginFromBrokerRequest}): Promise<MarginFromBrokerResponse> => {
    return new Promise((resolve, reject) => {
        const url = `trading-accounts/calculate-margin`
        api.post(url, JSON.stringify(args.request), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async(response)=>{
            const decodedData = MarginFromBrokerResponse.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error)=> {
            reject(error)
        })
    })
}

export const setAppPrimaryTradingAccount = async (tradingAccountId: string) => {
    let tradingAccounts = (store.getState().userStore as UserStateType)?.tradingAccounts ?? []
    const primaryIndex = tradingAccounts.findIndex((acc) => acc.accountId === tradingAccountId)
    if (primaryIndex > -1) {
        tradingAccounts = tradingAccounts.map((acc, index) => {
            if (index === primaryIndex) {
                return { ...acc, primary: true }
            } else {
                return { ...acc, primary: false }
            }
        })
    } else {
        tradingAccounts = (await getTradingAccounts()).tradingAccounts
        tradingAccounts = tradingAccounts.map((acc, index) => {
            if (index === primaryIndex) {
                return { ...acc, primary: true }
            } else {
                return { ...acc, primary: false }
            }
        })
    }
    refetchPositionsAndOrders(tradingAccounts, true)
}

let positionsFetchInFlight: Promise<void | undefined> | null = null
let positionsLoadedForAccountId: string | null = null

export const markPositionsLoaded = (accountId: string | undefined) => {
    if (accountId) positionsLoadedForAccountId = accountId
}

export const refetchPositionsAndOrders = async (alreadyTradingAccounts?: TradingAccount[], force = false) => {
    if (!force && positionsFetchInFlight) return positionsFetchInFlight
    const task = (async () => {
        let tradingAccounts = alreadyTradingAccounts
            ?? (store.getState().userStore as UserStateType)?.tradingAccounts
        let primaryTradingAccount = tradingAccounts?.find((acc) => acc.primary)
        if (!primaryTradingAccount) {
            try {
                const response = await getTradingAccounts()
                tradingAccounts = response.tradingAccounts
                primaryTradingAccount = tradingAccounts.find((acc) => acc.primary)
                store.dispatch(setTradingAccounts(tradingAccounts))
            } catch (error) {
                console.error('Failed to fetch trading accounts', error)
                return
            }
        }
        if (!primaryTradingAccount) {
            return
        }
        const accountId = primaryTradingAccount.accountId
        if (!force && positionsLoadedForAccountId === accountId) return
        positionsLoadedForAccountId = accountId
        const positionRequest = { tradingAccountId: accountId } as PositionRequest
        const [positionsResult, ordersResult] = await Promise.allSettled([
            getPositions({ body: { positionRequest } }),
            getOrders({ body: { tradingAccountId: accountId } })
        ])
        if (positionsResult.status === 'fulfilled') {
            store.dispatch(updatePositions({ positions: positionsResult.value.position, overwrite: true }))
        } else {
            positionsLoadedForAccountId = null
            console.error('Error fetching positions', positionsResult.reason)
        }
        if (ordersResult.status === 'fulfilled') {
            const orders = ordersResult.value.reverse()
            store.dispatch(setOrderHistory({ updates: orders }))
        } else {
            positionsLoadedForAccountId = null
            console.error('Error fetching orders', ordersResult.reason)
        }
    })()
    positionsFetchInFlight = task.finally(() => {
        positionsFetchInFlight = null
    })
    return positionsFetchInFlight
}

export const resetPracticeTradingAccount = async (tradingAccountId: string): Promise<TradingAccounts> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts/reset-practice`
        api.post(url, JSON.stringify({ tradingAccountId }), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccounts.decode(new Uint8Array(response.data))
            store.dispatch(setTradingAccounts(decodedData.tradingAccounts))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const setPracticeTradeEnabled = async (
    enabled: boolean,
    tradingAccountId?: string
): Promise<TradingAccounts> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts/practice-trade/enabled`
        const body: { enabled: boolean; tradingAccountId?: string } = { enabled }
        if (tradingAccountId) {
            body.tradingAccountId = tradingAccountId
        }
        api.post(url, JSON.stringify(body), {
            headers: {
                Accept: 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccounts.decode(new Uint8Array(response.data))
            store.dispatch(setTradingAccounts(decodedData.tradingAccounts))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}

export const setPrimaryTradingAccountApi = async (args: {
    body: any
}): Promise<TradingAccounts> => {
    return new Promise((resolve, reject) => {
        const url = `/trading-accounts/make-primary`
        api.post(url, JSON.stringify(args.body), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = TradingAccounts.decode(new Uint8Array(response.data))
            store.dispatch(setTradingAccounts(decodedData.tradingAccounts))
            const primaryTradingAccount = decodedData.tradingAccounts.find(acc => acc.primary)
            if (primaryTradingAccount) {
                sessionStorage.setItem(PRIMARY_TRADING_ACCOUNT_KEY, primaryTradingAccount.accountId)
                const body = {
                    accountId: primaryTradingAccount.accountId,
                    brokerCode: primaryTradingAccount.brokerCode,
                    created: primaryTradingAccount.created
                }
                const margin = await getAccountMargins({
                    body: body
                })
                store.dispatch(setMarginForAccount({ accountId: primaryTradingAccount.accountId, margin: margin }))
                await refetchPositionsAndOrders(decodedData.tradingAccounts, true)
            }
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}